export default {
	methods: {
		renderOrderStatus(orderStatus?: string | number) {
			const status = {
				label: "",
				color: "",
			};
			switch (orderStatus) {
				case "OnOrder":
				case 1:
					status.label = "On Order";
					status.color = "table-status-gray";
					break;
				case "Received":
				case 2:
					status.label = "Received";
					status.color = "table-status-green";
					break;
				case "Cancelled":
				case 3:
					status.label = "Cancelled";
					status.color = "table-status-orange";
					break;
				default:
					status.label = "Error";
					status.color = "table-status-orange";
			}
			return status;
		},
	},
};
